import {
  DateComponentWrapper,
  DateComponentContainer,
  DateComponentHeader,
  DateInputCalenderIconContainer,
} from "./DateComponent.styles";

import { CustomDatePicker } from "../../screens/User/analytics/form/incident-inputs";

export const DateComponent = ({
  startDate,
  endDate,
  setStartDate,
  setEndDate,
}: any) => {
  // xl:w-[233px]
  //  md:w-[130px]
  return (
    <DateComponentWrapper>
      <DateComponentContainer>
        <DateComponentHeader htmlFor="fromDate">From</DateComponentHeader>
        <DateInputCalenderIconContainer>
          <CustomDatePicker
            handleSetStartDates={(start) => {
              setStartDate(start);
            }}
            startDate={startDate}
            endDate={endDate}
            isStartDate={true}
            noBorder
          />
        </DateInputCalenderIconContainer>
      </DateComponentContainer>
      <DateComponentContainer>
        <DateComponentHeader htmlFor="toDate">To</DateComponentHeader>
        <DateInputCalenderIconContainer>
          <CustomDatePicker
            handleSetEndDates={(end) => {
              setEndDate(end);
            }}
            startDate={startDate}
            endDate={endDate}
            isStartDate={false}
            noBorder
          />
        </DateInputCalenderIconContainer>
      </DateComponentContainer>
    </DateComponentWrapper>
  );
};
